import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {StorageService} from '../../services/storage.service';
import {PermissoesService} from '../../services/permissoes.service';
import {ConsultaService} from '../../services/consulta.service';
import {SolicitacoesService} from '../../services/solicitacoes.service';

@Component({
    selector: 'app-modal-add-download-csv',
    templateUrl: './modal-add-download-csv.component.html',
    styleUrls: ['./modal-add-download-csv.component.scss']
})
export class ModalAddDownloadCsvComponent implements OnInit {
    @Input() corPrimaria: string;
    @Output() fecharModal = new EventEmitter();

  portfolio: any;
    nuCnes: any;
    nomeEstabelecimento: any;
    uf: any;
    municipio: any;

    constructor(
      private toast: ToastrService,
      private loading: NgxSpinnerService,
      private permissoesService: PermissoesService,
      private solicitacoesService: SolicitacoesService,
      private consultaService: ConsultaService,
    ) {}

    ngOnInit() {
    }

    fechar() {
      this.fecharModal.emit();
    }

    async consultarCnes() {
      if (this.nuCnes && this.nuCnes.length > 0) {
        this.loading.show();
        // const isResponsavel = await this.solicitacoesService.validarResponsavelCnes(this.nuCnes);
        // if (isResponsavel) {
        const result = await this.consultaService.consultarEstabelecimentoPorCNES(this.nuCnes);
        if (result) {
          this.nomeEstabelecimento = result.nomeFantasia;
          this.uf = result.siglaUF;
          this.municipio = result.nomeMunicipio;
        }
        // } else {
        //   this.toast.error('Atenção! O usuário logado não é Responsável pelo Estabelecimento informado.');
        // }
        this.loading.hide();
      } else {
          this.toast.error('Atenção! Informe o CNES desejado.');
      }
    }

    async selectState(portifolio) {
      console.log('portifolio', portifolio);
      this.portfolio = portifolio;
    }

    async adicionar() {
      if (!this.nuCnes || (this.nuCnes && this.nuCnes.length === 0)) {
        this.toast.error('Atenção! Informe o CNES desejado.');
        return false;
      }
      if (!this.nomeEstabelecimento || (this.nomeEstabelecimento && this.nomeEstabelecimento.length === 0)) {
        this.toast.error('Atenção! Realize a consulta do CNES desejado.');
        return false;
      }
      if (!this.portfolio || (this.portfolio && this.portfolio.length === 0)) {
        this.toast.error('Atenção! Informe o Portfólio desejado.');
        return false;
      }
      this.loading.show();
      const isSecretaria = await this.permissoesService.getValidarSecretaria(this.nuCnes).toPromise();
      if (isSecretaria) {
        const info = {
          cnes: this.nuCnes,
          idPortfolio: this.portfolio
        };
        this.fecharModal.emit(info);
      } else {
        this.fecharModal.emit(false);
        this.toast.error('Atenção! O Estabelecimento informado não é do Tipo Secretaria Estadual ou Municipal.');
      }
      this.loading.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-add-download-csv/modal-add-download-csv.component.ts